/* DMC Combo Finder — Mobile-first Discovery + Redirect (v4) */
(function () {
  'use strict';

  var instances = {};

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[character];
    });
  }

  function formatMoney(value) {
    return '₹' + Number(value || 0).toLocaleString('en-IN', {
      maximumFractionDigits: 2
    });
  }

  function normalizeCode(value) {
    var code = String(value == null ? '' : value).trim();
    return code ? code.padStart(3, '0') : '';
  }

  function normalizeComboKey(value) {
    return String(value == null ? '' : value)
      .split('|')
      .map(normalizeCode)
      .filter(Boolean)
      .sort(function (a, b) { return Number(a) - Number(b); })
      .join('|');
  }

  function buildSelectionKey(codes) {
    return codes
      .map(normalizeCode)
      .filter(Boolean)
      .sort(function (a, b) { return Number(a) - Number(b); })
      .join('|');
  }

  function codesInComboKey(key) {
    var normalized = normalizeComboKey(key);
    return normalized ? normalized.split('|') : [];
  }

  function readJson(root, selector) {
    var element = root.querySelector(selector);
    if (!element) return [];
    try {
      return JSON.parse(element.textContent || '[]');
    } catch (error) {
      console.warn('DMC Combo Finder JSON error:', selector, error);
      return [];
    }
  }

  function groupName(item) {
    var title = String(item.title || '').toLowerCase().trim();
    if (/^(mens|men's)\b/.test(title)) return 'mens';
    if (/^(womens|women's)\b/.test(title)) return 'womens';
    return 'accessories';
  }

  function groupLabel(group) {
    return {
      mens: 'Mens rental gear',
      womens: 'Womens rental gear',
      accessories: 'Trekking accessories'
    }[group] || 'Rental gear';
  }

  function groupRank(group) {
    return { mens: 1, womens: 2, accessories: 3 }[group] || 99;
  }

  function itemSort(a, b) {
    var groupDifference = groupRank(groupName(a)) - groupRank(groupName(b));
    if (groupDifference) return groupDifference;

    var titleDifference = String(a.title || '').localeCompare(String(b.title || ''), undefined, {
      numeric: true,
      sensitivity: 'base'
    });
    if (titleDifference) return titleDifference;

    return Number(a.code || 0) - Number(b.code || 0);
  }

  function State(root, items, combos) {
    this.root = root;
    this.items = (Array.isArray(items) ? items : []).sort(itemSort);
    this.combos = Array.isArray(combos) ? combos : [];
    this.selectedCodes = new Set();
  }

  function getSettings(root) {
    return {
      showComboImage: root.getAttribute('data-show-combo-image') === 'true',
      showDescription: root.getAttribute('data-show-description') === 'true',
      showComboItems: root.getAttribute('data-show-combo-items') === 'true',
      showSavings: root.getAttribute('data-show-savings') === 'true',
      showComboBadges: root.getAttribute('data-show-combo-badges') === 'true',
      showDeposit: root.getAttribute('data-show-deposit') === 'true',
      showDailyRate: root.getAttribute('data-show-daily-rate') === 'true',
      showRecommendations: root.getAttribute('data-show-recommendations') === 'true',
      showProductLinks: root.getAttribute('data-show-product-links') === 'true',
      showRateChartCta: root.getAttribute('data-show-rate-chart-cta') === 'true',
      maxRecommendations: Number(root.getAttribute('data-max-recommendations') || 4),
      comboButtonLabel: root.getAttribute('data-combo-button-label') || 'View combo & continue booking',
      productButtonLabel: root.getAttribute('data-product-button-label') || 'View item details',
      recommendationsHeading: root.getAttribute('data-recommendations-heading') || 'You can also consider',
      noMatchHeading: root.getAttribute('data-no-match-heading') || 'No ready-made combo for this selection',
      noMatchText: root.getAttribute('data-no-match-text') || 'You can still rent these items individually. Continue to the rental calculator to choose dates and location, share or download your quote, and complete your booking.',
      rateChartUrl: root.getAttribute('data-rate-chart-url') || '',
      rateChartButtonLabel: root.getAttribute('data-rate-chart-button-label') || 'Continue to rental calculator'
    };
  }

  function selectedItems(state) {
    return Array.from(state.selectedCodes).map(function (code) {
      return state.items.find(function (item) {
        return normalizeCode(item.code) === normalizeCode(code);
      });
    }).filter(Boolean).sort(itemSort);
  }

  function exactMatches(state) {
    var selectionKey = buildSelectionKey(Array.from(state.selectedCodes));
    if (!selectionKey) return [];

    return state.combos.filter(function (combo) {
      return normalizeComboKey(combo.comboKey) === selectionKey;
    }).sort(function (a, b) {
      return Number(a.displayOrder || 9999) - Number(b.displayOrder || 9999);
    });
  }

  function recommendations(state, exact) {
    var chosen = Array.from(state.selectedCodes).map(normalizeCode).filter(Boolean);
    if (!chosen.length) return [];

    var exactSet = new Set(exact.map(function (combo) {
      return normalizeComboKey(combo.comboKey);
    }));

    return state.combos.map(function (combo) {
      var codes = codesInComboKey(combo.comboKey);
      var codeSet = new Set(codes);
      var includesChosen = chosen.every(function (code) {
        return codeSet.has(code);
      });
      var extraItems = codes.length - chosen.length;

      if (!includesChosen || extraItems <= 0 || exactSet.has(normalizeComboKey(combo.comboKey))) {
        return null;
      }

      return { combo: combo, extraItems: extraItems };
    }).filter(Boolean).sort(function (a, b) {
      if (a.extraItems !== b.extraItems) return a.extraItems - b.extraItems;
      return Number(a.combo.displayOrder || 9999) - Number(b.combo.displayOrder || 9999);
    }).slice(0, getSettings(state.root).maxRecommendations).map(function (entry) {
      return entry.combo;
    });
  }

  function createItemButton(item, isSelected) {
    var code = normalizeCode(item.code);
    if (!code) return '';

    return '<button type="button" class="dmc-cf-item-button' +
      (isSelected ? ' is-selected' : '') +
      '" data-cf-item-code="' + escapeHtml(code) + '">' +
      (item.image ? '<img class="dmc-cf-item-button__image" src="' + escapeHtml(item.image) + '" alt="" loading="lazy">' : '') +
      '<span class="dmc-cf-item-button__title">' + escapeHtml(item.title) + '</span>' +
      '<span class="dmc-cf-item-button__check" aria-hidden="true">✓</span>' +
      '</button>';
  }

  function renderPicker(root, state) {
    var picker = root.querySelector('[data-cf-picker]');
    if (!picker) return;

    var groups = { mens: [], womens: [], accessories: [] };

    state.items.forEach(function (item) {
      groups[groupName(item)].push(item);
    });

    picker.innerHTML = ['mens', 'womens', 'accessories'].map(function (group) {
      if (!groups[group].length) return '';

      return '<div class="dmc-cf-picker-group dmc-cf-picker-group--' + group + '">' +
        '<h3 class="dmc-cf-picker-group__title">' + groupLabel(group) + '</h3>' +
        '<div class="dmc-cf-picker-grid">' +
          groups[group].map(function (item) {
            return createItemButton(item, state.selectedCodes.has(normalizeCode(item.code)));
          }).join('') +
        '</div>' +
      '</div>';
    }).join('');

    root.style.setProperty('--dmc-cf-mobile-columns', root.getAttribute('data-mobile-columns') || '2');
    root.style.setProperty('--dmc-cf-desktop-columns', root.getAttribute('data-desktop-columns') || '3');
  }

  function comboDestination(combo) {
    var url = String(combo.url || '').trim();
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') +
      'source=combo-finder&combo_key=' + encodeURIComponent(normalizeComboKey(combo.comboKey));
  }

  function createComboCard(combo, featured, settings) {
    var days = Number(combo.defaultDays || 0);
    var duration = days > 0
      ? 'for ' + days + ' day' + (days === 1 ? '' : 's') + ' rental'
      : 'rental charge';
    var details = [];
    var destination = comboDestination(combo);

    if (settings.showDailyRate && Number(combo.dailyRate || 0)) {
      details.push('Additional days: ' + formatMoney(combo.dailyRate) + ' / day');
    }

    if (settings.showDeposit) {
      var refundable = Math.max(0, Number(combo.securityDeposit || 0) - Number(combo.oneTimeCharge || 0));
      if (refundable > 0) {
        details.push('Refundable deposit: ' + formatMoney(refundable));
      }
    }

    var mediaHtml = '';
    if (settings.showComboImage) {
      if (combo.videoUrl) {
        mediaHtml = '<div class="dmc-cf-combo-card__media">' +
          '<video src="' + escapeHtml(combo.videoUrl) + '"' +
          (combo.videoPoster ? ' poster="' + escapeHtml(combo.videoPoster) + '"' : '') +
          (combo.autoPlayVideo ? ' autoplay muted loop playsinline' : ' controls') +
          '></video>' +
          (featured && settings.showComboBadges ? '<span class="dmc-cf-combo-card__ribbon">Best match</span>' : '') +
        '</div>';
      } else if (combo.image) {
        mediaHtml = '<div class="dmc-cf-combo-card__media">' +
          '<img src="' + escapeHtml(combo.image) + '" alt="" loading="lazy">' +
          (featured && settings.showComboBadges ? '<span class="dmc-cf-combo-card__ribbon">Best match</span>' : '') +
        '</div>';
      } else {
        mediaHtml = '<div class="dmc-cf-combo-card__media">' +
          (featured && settings.showComboBadges ? '<span class="dmc-cf-combo-card__ribbon">Best match</span>' : '') +
        '</div>';
      }
    } else {
      mediaHtml = '<div class="dmc-cf-combo-card__media">' +
        (featured && settings.showComboBadges ? '<span class="dmc-cf-combo-card__ribbon">Best match</span>' : '') +
      '</div>';
    }

    return '<article class="dmc-cf-combo-card' + (featured ? ' dmc-cf-combo-card--featured' : '') + '">' +
      mediaHtml +
      '<div class="dmc-cf-combo-card__body">' +
        '<h3 class="dmc-cf-combo-card__title">' + escapeHtml(combo.title || 'Rental combo') + '</h3>' +
        (settings.showDescription && combo.description ? '<p class="dmc-cf-combo-card__description">' + escapeHtml(combo.description) + '</p>' : '') +
        '<div class="dmc-cf-price-panel">' +
          '<div class="dmc-cf-price-panel__price">' + formatMoney(combo.oneTimeCharge) + '</div>' +
          '<div class="dmc-cf-price-panel__label">' + escapeHtml(duration) + '</div>' +
          (details.length ? '<div class="dmc-cf-price-panel__meta">' + details.map(escapeHtml).join('<br>') + '</div>' : '') +
        '</div>' +
        (settings.showSavings && combo.savingsLabel ? '<p class="dmc-cf-savings">' + escapeHtml(combo.savingsLabel) + '</p>' : '') +
        '<div class="dmc-cf-combo-card__footer">' +
          (destination
            ? '<a class="dmc-combo-finder__button dmc-combo-finder__button--primary" href="' + escapeHtml(destination) + '">' + escapeHtml(settings.comboButtonLabel) + '</a>'
            : '<span class="dmc-combo-finder__button dmc-combo-finder__button--disabled">View combo unavailable</span>') +
        '</div>' +
      '</div>' +
    '</article>';
  }

  function createIndividualCard(item, settings) {
    var days = Number(item.rentalDefaultDays || 0);
    var duration = days > 0
      ? 'for ' + days + ' day' + (days === 1 ? '' : 's') + ' rental'
      : 'rental charge';
    var details = [];

    if (settings.showDailyRate && Number(item.dailyRate || 0)) {
      details.push('Additional days: ' + formatMoney(item.dailyRate) + ' / day');
    }

    if (settings.showDeposit) {
      var refundable = Math.max(0, Number(item.securityDeposit || 0) - Number(item.oneTimeCharge || 0));
      if (refundable > 0) {
        details.push('Refundable deposit: ' + formatMoney(refundable));
      }
    }

    return '<article class="dmc-cf-combo-card">' +
      '<div class="dmc-cf-combo-card__body">' +
        '<h3 class="dmc-cf-combo-card__title">' + escapeHtml(item.title) + '</h3>' +
        '<div class="dmc-cf-price-panel">' +
          '<div class="dmc-cf-price-panel__price">' + formatMoney(item.oneTimeCharge) + '</div>' +
          '<div class="dmc-cf-price-panel__label">' + escapeHtml(duration) + '</div>' +
          (details.length ? '<div class="dmc-cf-price-panel__meta">' + details.map(escapeHtml).join('<br>') + '</div>' : '') +
        '</div>' +
        '<div class="dmc-cf-combo-card__footer">' +
          (settings.showProductLinks && item.url
            ? '<a class="dmc-cf-product-link" href="' + escapeHtml(item.url) + '">' + escapeHtml(settings.productButtonLabel) + ' →</a>'
            : '') +
        '</div>' +
      '</div>' +
    '</article>';
  }

  function renderSelection(root, state) {
    var container = root.querySelector('[data-cf-selection]');
    var button = container && container.querySelector('[data-cf-clear]');
    if (!container || !button) return;

    var hasSelection = state.selectedCodes.size > 0;
    container.hidden = !hasSelection;
    button.disabled = !hasSelection;
  }

  function updateUrl(state) {
    var params = new URLSearchParams(window.location.search);
    var handles = selectedItems(state).map(function (item) { return item.handle; }).filter(Boolean);

    if (handles.length) params.set('items', handles.join(','));
    else params.delete('items');

    window.history.replaceState({}, '', window.location.pathname +
      (params.toString() ? '?' + params.toString() : '') + window.location.hash);
  }

  function render(root, state) {
    var results = root.querySelector('[data-cf-results]');
    var fallback = root.querySelector('[data-cf-fallback]');
    var settings = getSettings(root);
    var selected = selectedItems(state);
    if (!results) return;

    renderSelection(root, state);

    if (!selected.length) {
      results.innerHTML = '<p class="dmc-combo-finder__empty-state">Select rental items to discover matching gear combos.</p>';
      if (fallback) fallback.hidden = true;
      updateUrl(state);
      return;
    }

    var exact = exactMatches(state);
    var suggested = settings.showRecommendations ? recommendations(state, exact) : [];
    var html = '';

    if (exact.length) {
      html += '<div class="dmc-cf-results-grid">' + exact.map(function (combo, index) {
        return createComboCard(combo, index === 0, settings);
      }).join('') + '</div>';
      if (fallback) fallback.hidden = true;
    } else {
      html += '<p class="dmc-cf-section-label">Rent these items individually</p>' +
        '<div class="dmc-cf-results-grid">' + selected.map(function (item) {
          return createIndividualCard(item, settings);
        }).join('') + '</div>';

      if (settings.showRateChartCta && settings.rateChartUrl) {
        html += '<div class="dmc-combo-finder__fallback" style="margin-top:14px;border:1px solid #eadfc8;border-radius:14px;padding:16px;background:linear-gradient(145deg,#fffaf2,#fffdf8);text-align:center;">' +
          '<h3 style="margin:0;color:#543f25;font-size:15px;font-weight:850;">' + escapeHtml(settings.noMatchHeading) + '</h3>' +
          '<p style="max-width:680px;margin:6px auto 12px;color:#77634a;font-size:11px;line-height:1.45;">' + escapeHtml(settings.noMatchText) + '</p>' +
          '<a class="dmc-combo-finder__button dmc-combo-finder__button--primary" href="' + escapeHtml(settings.rateChartUrl) + '">' + escapeHtml(settings.rateChartButtonLabel) + '</a>' +
        '</div>';
      }

      if (fallback) fallback.hidden = true;
    }

    if (suggested.length) {
      html += '<div class="dmc-cf-recommendations">' +
        '<p class="dmc-cf-section-label">' + escapeHtml(settings.recommendationsHeading) + '</p>' +
        '<div class="dmc-cf-results-grid">' + suggested.map(function (combo) {
          return createComboCard(combo, false, settings);
        }).join('') + '</div></div>';
    }

    results.innerHTML = html;
    updateUrl(state);
  }

  function restoreSelection(state) {
    var params = new URLSearchParams(window.location.search);
    var handles = (params.get('items') || '').split(',').filter(Boolean);

    state.items.forEach(function (item) {
      if (handles.indexOf(String(item.handle)) !== -1) {
        var code = normalizeCode(item.code);
        if (code) state.selectedCodes.add(code);
      }
    });
  }

  function bindEvents(root, state) {
    root.addEventListener('click', function (event) {
      var itemButton = event.target.closest('[data-cf-item-code]');
      if (itemButton && root.contains(itemButton)) {
        var code = normalizeCode(itemButton.getAttribute('data-cf-item-code'));
        if (!code) return;

        if (state.selectedCodes.has(code)) state.selectedCodes.delete(code);
        else state.selectedCodes.add(code);

        renderPicker(root, state);
        render(root, state);
        return;
      }

      var clearButton = event.target.closest('[data-cf-clear]');
      if (clearButton && root.contains(clearButton)) {
        state.selectedCodes.clear();
        renderPicker(root, state);
        render(root, state);
      }
    });
  }

  function init(sectionId) {
    var root = document.getElementById(sectionId);
    if (!root) return;

    instances[sectionId] = null;

    var state = new State(
      root,
      readJson(root, '[data-cf-items]'),
      readJson(root, '[data-cf-combos]')
    );

    restoreSelection(state);
    instances[sectionId] = { root: root, state: state };

    renderPicker(root, state);
    bindEvents(root, state);
    render(root, state);
  }

  function initFromSection(section) {
    var root = section && section.matches('.dmc-combo-finder')
      ? section
      : section && section.querySelector('.dmc-combo-finder');
    if (root && root.id) init(root.id);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.dmc-combo-finder[id]').forEach(function (root) {
      init(root.id);
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    initFromSection(event.target);
  });

  document.addEventListener('shopify:section:reorder', function (event) {
    initFromSection(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector('.dmc-combo-finder');
    if (root && root.id) delete instances[root.id];
  });

  window.DMCComboFinder = { init: init };
})();